import React, { useState } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { 
  Box,
  CircularProgress,
  Dialog,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Typography ,
  Tab,
  Tabs,
  Button,} from "@mui/material";
import { downloadStationHistoryData, downloadAreaHistoryDate } from '../../services/download';

function onDownloadHandle(props, selectDateValue) {
  let startDate = selectDateValue[0]
  startDate.setHours(0, 0, 1)
  let endDate = selectDateValue[1]
  endDate.setHours(23, 59, 59)
  if(props.type==='station') {
    downloadStationHistoryData(
      props.type,
      props.stn,
      startDate,
      endDate
    )
  } else {
    downloadAreaHistoryDate(
      props.type,
      props.tambon,
      props.amphoe,
      props.province,
      startDate,
      endDate
    )
  }
}

function DownloadContent(props) {
  let startDate = new Date()
  let endDate = new Date()
  startDate.setDate(new Date().getDate()-6)
  const [selectDateValue, onDateChange] = useState([startDate, endDate]);

  return (
    <Grid container px={5} py={3} >
      <Divider></Divider>
      <Grid item xs={4}>
        <Typography> ข้อมูลย้อนหลังรายวัน </Typography>
      </Grid>
      <Grid item xs={6}>
        <DateRangePicker format="dd/MM/y" onChange={onDateChange} value={selectDateValue} />
      </Grid>
      <Grid item xs={2}>
        <Button onClick={() => onDownloadHandle(props, selectDateValue)}> ดาวน์โหลด </Button>
      </Grid>
    </Grid>
  );
}

export default DownloadContent;